#import "../fragments/role-fragment.graphql"

mutation UpdateRole($input: RoleUpdateInput!) {
    roleUpdate(input: $input) {
        role {
            ...RoleFragment
        }
    }
}
